import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "port-data joboffer" }
const _hoisted_2 = { href: "#" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "all-colors" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseModal = _resolveComponent("BaseModal")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_BaseModal, { id: 'joboffer-modal' }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("h2", null, _toDisplayString(_ctx.item.title), 1),
          _createVNode("a", _hoisted_2, _toDisplayString(_ctx.item.place), 1),
          _hoisted_3,
          _createVNode("div", {
            innerHTML: _ctx.item.desc
          }, null, 8, ["innerHTML"])
        ])
      ]),
      _: 1
    })
  ]))
}